module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Join-2-015bf19c78fd1cdda09bc9491b7d3c46.svg";